define(["require", "exports", "tslib", "mobx", "mobx-react", "react", "../model/services/ServiceError", "../model/services/SrmsServiceManager", "../utils/EntityUtil", "./blocks"], function (require, exports, tslib_1, mobx_1, mobx_react_1, React, ServiceError_1, SrmsServiceManager_1, EntityUtil_1, blocks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ErrorReportView = void 0;
    React = tslib_1.__importStar(React);
    const style = {
        sendToSupport: {
            background: "rgba(100, 100, 100, 0.04)",
            border: "1px dashed #CCCCCC",
            marginTop: 10,
            padding: 14
        }
    };
    class ErrorReportState {
        constructor() {
            Object.defineProperty(this, "comment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: "If you are sending an error report to support, type a comment here to describe the issue"
            });
            Object.defineProperty(this, "isSent", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            Object.defineProperty(this, "showAll", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
        }
    }
    tslib_1.__decorate([
        mobx_1.observable
    ], ErrorReportState.prototype, "comment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ErrorReportState.prototype, "isSent", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ErrorReportState.prototype, "showAll", void 0);
    let ErrorReportView = exports.ErrorReportView = class ErrorReportView extends React.Component {
        constructor(props) {
            super(props);
            Object.defineProperty(this, "messageId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "vm", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "sendToSupport", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    var _a;
                    try {
                        const screenshotBase64 = "NONE";
                        const err = this.props.error;
                        if (err instanceof ServiceError_1.ServiceError) {
                            SrmsServiceManager_1.SrmsServiceManager.Instance.Admin.logErrorWithSupport(this.messageId, `${window.location.hostname}${window.location.pathname}`, err.Service, err.Method, err.Message, (_a = err.Code) === null || _a === void 0 ? void 0 : _a.toString(), err.StackTrace, JSON.stringify(err.Inputs) + ".", screenshotBase64, this.vm.comment.trim())
                                .then((result) => {
                                this.vm.isSent = true;
                            })
                                .catch((ex) => {
                                console.error(ex);
                            });
                        }
                        else {
                            SrmsServiceManager_1.SrmsServiceManager.Instance.Admin.logErrorWithSupport(this.messageId, `${window.location.hostname}${window.location.pathname}`, "", "", err.message, "", err.stack, "", screenshotBase64, this.vm.comment.trim())
                                .then(() => {
                                this.vm.isSent = true;
                            })
                                .catch((ex) => {
                                console.error(ex);
                            });
                        }
                    }
                    catch (ex) {
                        console.error(ex);
                        this.vm.isSent = false;
                    }
                }
            });
            Object.defineProperty(this, "toggleShowMore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: () => {
                    this.vm.showAll = !this.vm.showAll;
                }
            });
            this.messageId = (0, EntityUtil_1.id)().toString();
            this.vm = new ErrorReportState();
        }
        renderErrorBody(err) {
            if (err.Level === ServiceError_1.ServiceErrorLevel.Info) {
                return null;
            }
            return (React.createElement(blocks_1.VGroup, null,
                this.vm.showAll
                    ?
                        React.createElement(blocks_1.VGroup, null,
                            React.createElement("div", null, err.Message),
                            err.Service || err.Method
                                ? React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, "API Endpoint"),
                                    React.createElement("div", null,
                                        err.Service,
                                        ".",
                                        err.Method))
                                : null,
                            err.Inputs
                                ? React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, "Inputs"),
                                    React.createElement("pre", { className: "modal-pre" },
                                        React.createElement("code", null, JSON.stringify(err.Inputs))))
                                : null,
                            err.Code
                                ? React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, "Code"),
                                    React.createElement("div", null, err.Code))
                                : null,
                            err.StackTrace
                                ? React.createElement(React.Fragment, null,
                                    React.createElement("h4", null, "Stacktrace"),
                                    React.createElement("pre", { className: "modal-pre" },
                                        React.createElement("code", null, err.StackTrace)))
                                : null)
                    : null,
                React.createElement(blocks_1.CtaButton, { label: this.vm.showAll ? "Hide details" : "Show details", autoFocus: false, onClick: this.toggleShowMore })));
        }
        render() {
            const err = this.props.error;
            if (!err) {
                return null;
            }
            const isInfo = err instanceof ServiceError_1.ServiceError && err.Level === ServiceError_1.ServiceErrorLevel.Info;
            return React.createElement(blocks_1.VGroup, { style: { paddingTop: 10 } },
                err instanceof ServiceError_1.ServiceError
                    ? this.renderErrorBody(err)
                    : React.createElement(blocks_1.VGroup, null,
                        React.createElement("div", null, err.message),
                        React.createElement("h4", null, "Stacktrace"),
                        React.createElement("pre", { className: "modal-pre" },
                            React.createElement("code", null, err.stack))),
                !isInfo
                    ? React.createElement(blocks_1.VGroup, { style: style.sendToSupport },
                        React.createElement("h4", null, "User Comments"),
                        React.createElement(blocks_1.TextField, { id: "Comment", hideLabel: true, propertyOwner: this.vm, propertyName: "comment", multiLine: true, rows: 2, disabled: this.vm.isSent }),
                        React.createElement(blocks_1.CtaButton, { label: this.vm.isSent ? "Sent" : "Send to support", color: "primary", autoFocus: true, onClick: this.sendToSupport, disabled: this.vm.isSent }))
                    : null);
        }
    };
    exports.ErrorReportView = ErrorReportView = tslib_1.__decorate([
        mobx_react_1.observer
    ], ErrorReportView);
});
